import Grid from "@mui/material/Grid/Grid";
import {
    CustomLabelMediumBold,
    CustomLabelMediumRegular, CustomLabelMediumSmallBold, CustomLabelRegularLargeMedium,
    CustomLabelSmallBold,
    CustomLabelSmallMedium
} from "../common/CustomLabel";
import Slider from "react-slick/lib";
import Box from "@mui/material/Box/Box";
import TEAM_MEMBER from "../../assets/images/team-member.png";
import React from "react";


const OurTeam=({title,description,developers})=>{


    return(
        <Grid item xs={12} container sx={{padding: {xs: '0px 0px', sm: "12px 0px", md: '12px 20px', lg: "12px 50px", xl: "12px 60px"}}} justifyContent={"center"}>

        {title && (
            <>
                <Grid item container justifyContent={"center"} sx={{marginTop: {xs: "60px", md: "60px"}}}>
                    <CustomLabelMediumSmallBold text={title} color={"#5E17EB"}/>
                </Grid>

                <Grid item container style={{marginTop: "15px"}} justifyContent={"center"}>
                    <CustomLabelRegularLargeMedium 
                        normal={false}
                        text={description}
                    />
                </Grid>
            </>
        )}

            <Grid item container justifyContent={"center"} xs={12}
                  sx={{ marginTop: {xs: "20px", md: "40px"},gap:"15px"}}>
                {
                    developers.map((d)=>
                            <Grid item xs={12} sm={5.5}  md={3.8} lg={3.5}>
                                <Grid item xs={12} container direction={"column"} alignItems={"center"}>
                                <Grid item sx={{width:"100%"}}>
                                    <Box component={"div"} className="zoom-image-container"
                                         sx={{
                                             width: "100%",
                                             borderRadius: "25px",
                                             border: "1px solid #C5C5C5",
                                         }}
                                    >
                                        <Box component={"img"} src={d.img} alt={d.name} className={"bw-hover zoom-in"}/>
                                    </Box>
                                </Grid>
                                <Grid item sx={{marginTop:"5px"}}>
                                    <CustomLabelSmallBold text={d.name} color={"#5E17EB"}/>
                                </Grid>
                                <Grid item sx={{marginTop:"2px"}}>
                                    <CustomLabelSmallMedium text={d.role}/>
                                </Grid>
                                </Grid>
                        </Grid>

                    )
                }
            </Grid>
        </Grid>
    )
}


export default OurTeam;
